<template>
  <PaFrontForm
    class="pa-message-additional-box"
    :class="additionalFormClass"
    :action="'/'"
    :formSetClass="['form-set-primary']"
    :formSet="formSet"
    :submitText="'変更'"
    :submitLoading="isFormLoading"
    :isDisabledButton="isDisabledButton"
    :validationMessagePosition="'bottom'"

    :hasSubmitButton="false"
    :hasCancelButton="false"
    
    @handleSubmit="handleSubmit"
    @handleCancel="handleCancel"
    @handleChangeSwitch="handleChangeSwitch"
    @handleClickButton="handleClickButton"
  />
</template>

<script>
import FormValidationControlMixin from '@/mixins/FormValidationControlMixin.js'

import PaFrontForm from '@/components/FrontParts/PaFrontForm/PaFrontForm.vue'

import {GetUserMeta}  from '@/graphql/queries/User.graphql'

export default {
  props : {
    isLoading   : {
      default: false,
    },

    isDisabled  : {
      default: false,
    },

    serverValidationError : {
      default: null
    },
  },
  
  mixins : [
    FormValidationControlMixin
  ],

  components : {
    PaFrontForm
  },

  data(){
    return {
      isFormLoading : false,

      formSet       : {
        mailNotification  : {
          label             : 'メール通知',
          description       : 'この項目をオンすると塔経瞬時に登録された貴方様へのお知らせをメールにて通知致します。',
          descriptionMinify : true,
          switchLabel       : 'メール通知を許可する',
          validationRules   : [],
          inputType         : 'switch',
          isDisabled        : false,
        },

        mailNewsLetter  : {
          label             : 'メール通知に告知・お知らせを含める',
          description       : '不定期にメールマガジン形式でシステムの更新やストーリーの追加、イベント等の告知を配信致します。メール通知自体がオフの場合はこの項目だけをオンにしても配信されません。',
          descriptionMinify : true,
          switchLabel       : '告知・お知らせの通知を許可する',
          validationRules   : [],
          inputType         : 'switch',
          isDisabled        : false,
        },

        pushNotification  : {
          label             : 'プッシュ通知（ウェブブラウザ用）',
          description       : 'プッシュ通知は１デバイスのみ登録可能です。複数回設定した場合、最後に設定したデバイスのみで有効です。(iOS端末では端末の仕様上、ウェブブラウザ用のプッシュ通知機能を使用することができません。)',
          descriptionMinify : true,
          buttonText        : '設定ダイアログを開く',
          validationRules   : [],
          inputType         : 'button',
          isDisabled        : false,
        },
      },

      isDisabledFormFields  : false,

      additionalFormClass : [],

      userMeta            : null,
    }
  },

  apollo : {
    userMetaList: {
      query: GetUserMeta,
      fetchPolicy: 'no-cache'
    }
  },

  computed : {
    queryLoading(){
      if(typeof this.$apollo.queries.userMetaList === 'undefined') return false;

      return this.$apollo.queries.userMetaList.loading;
    }
  },

  watch : {
    queryLoading(value){
      this.isFormLoading = value;
    },

    userMetaList : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.userMeta = JSON.parse(data.data);
      },
      immediate: true,
      deep: true
    },

    userMeta : {
      handler(data){
        if(data === null) return;
        if(typeof data !== 'object') return;
        
        if(typeof data['notifications.allowEmail'] !== 'undefined'){
          this.formSet.mailNotification.value = data['notifications.allowEmail'];
        }

        if(typeof data['notifications.emailNewsLetter'] !== 'undefined'){
          this.formSet.mailNewsLetter.value = data['notifications.emailNewsLetter'];
        }
      },
      immediate: true,
      deep: true
    },

    isDisabled  : {
      handler(value){
        if(value === true){
          this.isDisabledButton     = true;
          this.buttonClass          = ['button-disabled'];
          this.additionalFormClass  = ['pa-message-additional-box-disabled'];

          this.isDisabledFormFields = true;
        }else{
          this.isDisabledButton     = false;
          this.buttonClass          = [];
          this.additionalFormClass  = [];

          this.isDisabledFormFields = false;
        }
      },
      immediate: true
    },

    isLoading   : {
      handler(value){
        if(value === true){
          this.isFormLoading = true;
        }else{
          this.isFormLoading = false;
        }
      }
    },

    isFormLoading : {
      handler(value){
        this.isDisabledFormFields = value;
      }
    },

    isDisabledFormFields  : {
      handler(value){
        if(value === true){
          this.disabledFields();
        }else{
          this.unDisabledFields();
        }
      },
      immediate: true
    },

    serverValidationError : {
      handler(data){
        if(data === null) return;
        console.log(data);
        if(data.first.category === 'validation'){
          this.unValidateField({
            fieldName : data.first.field,
            message   : data.first.message,
          });
        }
      },
      immediate: true,
      deep:true
    }
  },

  methods : {
    handleSubmit(){
      if( this.checkFormPreValidation() ){
        this.$emit('onSubmit', this.formSet);
      }else{
        console.log('validation error');
      }
    },
    
    handleCancel(){
      this.$emit('onCancel');
    },

    handleChangeSwitch(name){
      // console.log(name);
      // switch(name){
      //   case 'mailNotification':
      //   break;
      // }
      this.$emit('onSubmit', this.formSet, {
        inProgressField : name
      });
    },

    handleClickButton(){
      this.$emit('onSubmit', this.formSet, {
        inProgressField : 'pushNotification'
      });
    }
  },

  mounted(){
    // IOSの場合はPUSH通知をDisabledに変更する
    const isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent)
    
    if(isIOS){
      this.formSet.pushNotification.isDisabled = true;
    }

    // setTimeout(() => {
    //   this.formSet.mailNotification.value = true;
    // }, 2000);
  }
}
</script>

<style lang="scss">
  @import "@/components/Pages/Office/MessageApp/MessageAppForm.scss";
</style>